import { render } from "./PanelView.vue?vue&type=template&id=6bfc95b3&scoped=true"
import script from "@/controllers/panelController.js?vue&type=script&lang=js"
export * from "@/controllers/panelController.js?vue&type=script&lang=js"

import "@/styles/panel.css?vue&type=style&index=0&lang=css"
import "./PanelView.vue?vue&type=style&index=1&id=6bfc95b3&scoped=true&lang=css"

import exportComponent from "/home/jocelino/IGAMES-PS2/panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bfc95b3"]])

export default __exports__